import { render, staticRenderFns } from "./BowCoverImmobile.vue?vue&type=template&id=69a13fd7&"
import script from "./BowCoverImmobile.vue?vue&type=script&lang=js&"
export * from "./BowCoverImmobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowVideo: require('/workspace/components/atoms/BowVideo/BowVideo.vue').default,BowImage: require('/workspace/components/atoms/BowImage/BowImage.vue').default,BowOverlay: require('/workspace/components/atoms/BowOverlay/BowOverlay.vue').default,BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowFeatureGroup: require('/workspace/components/molecules/BowFeatureGroup/BowFeatureGroup.vue').default,BowButton: require('/workspace/components/atoms/BowButton/BowButton.vue').default})
